import TopicsModal from './TopicsModal.react';

export default TopicsModal;
